<template>
  <div class="books-right-container">
    <div class="right-header flex-between">
      <div class="flex-row-start">
        <a
          href="javascript:;"
          class="sign column"
          :class="{ active: tabIndex == index }"
          v-for="(item, index) in tabList"
          :key="index"
          @click="onSelectTab(index)"
          >{{ item.title }}</a
        >
      </div>
      <div class="flex-row-end">
        <div class="circle"></div>
        <div class="right-header-text">
          累积作业次数<span class="num"> {{ totalCount }}</span>
        </div>
        <!-- <div class="right-header-text">
          已激活学科：<span class="num">0</span>
        </div> -->
      </div>
    </div>
    <div class="right-main right-main-list" v-if="isNull">
      <div
        class="item-box flex-between"
        v-for="(v, k) in homeworkList"
        :key="k"
      >
        <div>
          <div class="books-list-title">
            <span class="class-code-id fw">{{ v.class_code }}</span>
            <span class="class-name fw">班级作业名称：</span>
            <span class="work-name">{{ v.name }}</span>
          </div>
          <div class="work-info">
            <span class="w-i-item"
              >学段：<span class="c-40b8ee">{{ v.stage_name }}</span></span
            >
            <span class="w-i-item"
              >学科：<span class="c-40b8ee">{{ v.subject_name }}</span></span
            >
            <span class="w-i-item"
              >题量：<span class="c-40b8ee">{{ v.question_count }}</span></span
            >
            <span class="w-i-item"
              >已提交：<span class="c-40b8ee">{{ v.student_hand_count }}</span
              >人</span
            >
            <span class="w-i-item"
              >未提交：<span class="c-40b8ee">{{
                v.student_count - v.student_hand_count
              }}</span
              >人</span
            >
          </div>
        </div>
        <div class="flex-between" v-if="v.status">
          <div class="score">
            <div class="score-text">我的得分率</div>
            <div class="score-num c-bc4654" v-if="v.status">
              {{ v.accuracy }}%
            </div>
          </div>
          <div>
            <el-button type="primary" @click="onStudentList(v)"
              >作业详情</el-button
            >
          </div>
        </div>
        <div class="flex-between" v-else>
          <div class="score"></div>
          <div>
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="onAnswerQuestions(v)"
              >答题</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="right-main column" v-else>
      <img src="../../assets/images/list_null.png" alt="" srcset="" />
      <div class="null">暂无数据~~</div>
    </div>
    <div class="clearfix flex-row-end">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="query.page"
        :page-size="query.pageSize"
        :total="totalCount"
        @current-change="handlePageChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      class="dialog-padding books-dialog"
      :title="dialog.title"
      :visible.sync="dialog.status"
      width="960px"
    >
      <div class="dialog-header flex-between">
        <div class="dialog-header-item active">成绩一览</div>
        <div class="dialog-header-item" @click="onAnswerQuestions(homeworkIng)">
          逐题分析
        </div>
      </div>
      <div class="dialog-content flex-between">
        <div class="dialog-info">
          <div class="d-head flex-between">
            <div class="d-head-item">
              <div class="d-head-box">
                <div class="d-head-title">我的成绩</div>
                <div class="d-head-score">
                  <div>
                    <div class="d-head-score-item ">
                      总题数：{{ homeworkIng.question_count }}道
                    </div>
                    <!-- <div class="d-head-score-item ">满分：100分</div> -->
                  </div>
                  <div class="score-num" v-if="homeworkIng.status">
                    {{ homeworkIng.accuracy }}%
                  </div>
                  <div class="score-num" v-else>{{ homeworkIng.accuracy }}</div>
                  <div class="score-text">我的得分率</div>
                </div>
              </div>
            </div>
            <div class="d-head-item dashed">
              <div class="d-head-box">
                <div class="d-head-title">知识点分析</div>
                <div>
                  <div>作业涉及知识点：{{ workKnowledgeCount }}</div>
                  <GeminiScrollbar class="d-head-k">
                    <span
                      class="item"
                      v-for="(w, k) in workKnowledgeList"
                      :key="k"
                      >{{ w }}</span
                    >
                  </GeminiScrollbar>
                </div>
              </div>
            </div>
            <div class="d-head-item">
              <div class="d-head-box">
                <div class="d-head-title">作答用时统计</div>
                <div>
                  <div class="mb10">
                    推荐作业用时：<span class="c-40b8ee">{{
                      homeworkIng.recommended_time
                    }}</span
                    >分钟
                  </div>
                  <div class="mt10">
                    你的累计用时：<span class="c-40b8ee">{{
                      homeworkIng.time
                    }}</span>
                  </div>
                  <div class="mt10">
                    用时评价：<span class="c-40b8ee">{{
                      homeworkIng.quiz_time_evaluation
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-center">
            <div class="d-head-title">作业得分详情</div>
            <div class="work-info-table flex-between">
              <div>
                <template>
                  <el-table :data="homeworkInfo" border>
                    <el-table-column prop="name" label="作业名称" width="180px">
                      <template slot-scope="scope"
                        ><div class="homework-info-name">
                          {{ scope.row.name }}
                        </div></template
                      >
                    </el-table-column>
                    <el-table-column
                      prop="correct_accuracy"
                      label="我的得分率"
                      width="100px"
                    >
                      <template slot-scope="scope"
                        ><span
                          >{{ scope.row.correct_accuracy }}%</span
                        ></template
                      >
                    </el-table-column>
                    <el-table-column
                      prop="avg_num"
                      label="班级平均得分率"
                      width="120px"
                    >
                      <template slot-scope="scope"
                        ><span>{{ scope.row.avg_num }}%</span></template
                      >
                    </el-table-column>
                    <el-table-column
                      prop="max_num"
                      label="班级最高得分率"
                      width="120px"
                    >
                      <template slot-scope="scope"
                        ><span>{{ scope.row.max_num }}%</span></template
                      >
                    </el-table-column>
                  </el-table>
                </template>
              </div>
              <div>
                <template>
                  <el-table :data="homeworkInfo" border>
                    <el-table-column
                      prop="num"
                      label="作业表现"
                      width="120px"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-rate
                          :value="scope.row.score"
                          disabled
                          :max="3"
                          :colors="colors"
                        >
                        </el-rate>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </div>
            </div>
            <div class="state flex-row-start">
              <span class="state-text">说明：作业表现情况</span>
              <div class="rate-item flex-row-start">
                <el-rate :value="0" disabled :max="3"> </el-rate>不合格
              </div>
              <div class="rate-item flex-row-start">
                <el-rate :value="1" disabled :max="3" :colors="colors">
                </el-rate
                >合格
              </div>
              <div class="rate-item flex-row-start">
                <el-rate :value="2" disabled :max="3" :colors="colors">
                </el-rate
                >良好
              </div>
              <div class="rate-item flex-row-start">
                <el-rate :value="3" disabled :max="3" :colors="colors">
                </el-rate
                >优秀（满分）
              </div>
            </div>
          </div>
          <div class="d-bottom">
            <div class="d-head-title">薄弱知识点</div>
            <template>
              <el-table :data="knowledgeList" height="240" border>
                <el-table-column prop="name" label="知识点"> </el-table-column>
                <el-table-column prop="num" label="涉及题数"> </el-table-column>
                <el-table-column prop="correct_accuracy" label="我的得分率">
                  <template slot-scope="scope"
                    ><span>{{ scope.row.correct_accuracy }}%</span></template
                  >
                </el-table-column>
                <el-table-column prop="avg_num" label="班级平均得分率">
                  <template slot-scope="scope"
                    ><span>{{ scope.row.avg_num }}%</span></template
                  >
                </el-table-column>
                <el-table-column prop="max_accuracy" label="班级最高得分率">
                  <template slot-scope="scope"
                    ><span>{{ scope.row.max_accuracy }}%</span></template
                  >
                </el-table-column>
              </el-table>
            </template>
          </div>
        </div>
        <div class="dialog-video">
          <div class="v-head-title">推荐课程</div>
          <GeminiScrollbar
            class="dialog-video-list"
            v-if="courseList.length > 0"
          >
            <div
              class="video-item column"
              v-for="(c, k) in courseList"
              :key="k"
              @click="onVideo(c)"
            >
              <div class="video" :title="c.ke_title">
                <img
                  :src="`https://api.canpoint.net/wk/AliyunVideo/getimgyurl?vid=${c.video_id}`"
                  class="course-image"
                  alt=""
                />

              </div>
              <div class="video-title" :title="c.ke_title">{{ c.ke_title }}</div>
            </div>
          </GeminiScrollbar>
          <div class="dialog-video-list column" v-else>暂无课程</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from "../../config/mUtils.js";
export default {
  data() {
    return {
      isNull: true,
      dialog: { status: false, title: "作业详情" },
      tabList: [
        { title: "正在进行" },
        { title: "作业历史" },
        // { title: "学习成就" },
      ],
      tabIndex: 0,
      colors: ["#bc4654", "#bc4654", "#bc4654"],
      homeworkList: [],
      query: {
        page: 1,
        pageSize: 10,
      },
      totalCount: 0,
      homeworkIng: {},
      homeworkInfo: [],
      knowledgeList: [],
      workKnowledgeList: [],
      workKnowledgeCount: 0,
      courseList: [],
    };
  },
  created() {
    this.getHomeworkList();
  },
  methods: {
    getHomeworkList() {
      this.getRequest(
        "/wenjiaoopne/kc/students/homeworkList",
        Object.assign(this.query, { types: this.tabIndex })
      )
        .then((result) => {
          this.homeworkList = result.data.list;
          this.totalCount = result.data.total_count;
          this.isNull = this.homeworkList.length > 0;
        })
        .catch(() => {});
    },
    // 切换选项卡触发事件
    onSelectTab(i) {
      this.query = {
        page: 1,
        pageSize: 10,
      };
      this.tabIndex = i;
      this.getHomeworkList();
    },
    onStudentList(v) {
      this.onLoading();
      this.getRequest("/wenjiaoopne/kc/students/homework", {
        home_work_code: v.home_work_code,
      })
        .then((result) => {
          this.loading.close();
          this.homeworkIng = v;
          this.homeworkIng.time = formatDate(v.quiz_time);
          this.homeworkInfo = result.data.homework_info;
          this.workKnowledgeList = result.data.list;
          this.workKnowledgeCount = result.data.total_count;
          this.knowledgeList = result.data.knowledge_list;
          this.courseList = result.data.course_list;
          this.dialog.status = true;
        })
        .catch(() => {
          this.loading.close();
        });
    },
    onAnswerQuestions(v) {
      this.$router.push(`/student/homework/${v.home_work_code}`);
    },
    handlePageChange(v) {
      this.$set(this.query, "page", v);
      this.getHomeworkList();
    },
    onVideo(v) {
      this.$router.push({ path: `/video/${v.video_id}` });
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>
<style scoped>
.books-right-container {
  float: right;
  width: 930px;
  padding-right: 25px;
  box-sizing: border-box;
  background-color: #fff;
  color: #333;
}
.books-right-container .right-header {
  height: 130px;
  padding-top: 2px;
}
.books-right-container .sign {
  width: 123px;
  height: 49px;
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/3.png");
  color: #fff;
}
.books-right-container .sign {
  margin-right: 10px;
}
.books-right-container .active {
  background-image: url("../../assets/images/2.png");
}
.books-right-container .right-header-text {
  color: #bcc8dd;
  margin-left: 10px;
}
.books-right-container .num {
  display: inline-block;
  color: #40b8ee;
}

.books-right-container .circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-top: 2px;
  background-color: #40b8ee;
  vertical-align: middle;
}
.books-right-container .item-box {
  background-color: #ebf7fe;
  padding: 20px 30px;
  margin-bottom: 8px;
}
.books-right-container .right-main {
  font-size: 14px;
}
.books-right-container .books-list-title {
  margin-bottom: 8px;
  font-size: 16px;
}
.books-right-container .class-code-id {
  color: #bc4654;
}
.books-right-container .class-name {
  color: #000;
}
.books-right-container .work-name {
  color: #40b8ee;
}
.books-right-container .work-info {
  color: #7a8aa3;
}
.books-right-container .w-i-item {
  display: inline-block;
  margin-right: 15px;
}
.books-right-container .score {
  margin-right: 30px;
}
.books-right-container .score-text {
  color: #7a8aa3;
}
.books-right-container .score-num {
  font-size: 30px;
}
.books-right-container .right-main {
  min-height: 430px;
}
.dialog-header .dialog-header-item {
  padding: 10px 0;
  width: 50%;
  text-align: center;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
.dialog-header .dialog-header-item {
  background: #40b8ee;
}
.dialog-header .active {
  background: #bc4654;
}
.books-dialog .dialog-content {
  height: 620px;
}
.books-dialog .dialog-content .dialog-info {
  width: 750px;
  height: 620px;
}
.books-dialog .d-head .d-head-item {
  width: 33%;
  height: 150px;
  margin-top: 10px;
}
.books-dialog .d-head .dashed {
  border-left: 2px dotted #ebf7fe;
  border-right: 2px dotted #ebf7fe;
}
.homework-info-name {
  width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.d-head-box {
  padding: 0 20px;
}
.d-head-title {
  color: #333;
  border-left: 4px solid #bc4654;
  padding-left: 5px;
  font-size: 14px;
  font-weight: 700;
  margin: 10px 0;
}
.d-head-score .score-num {
  font-size: 40px;
  color: #bc4654;
  text-align: center;
  margin: 5px 0;
}
.score-text {
  text-align: center;
}
.d-head-score-item {
  color: #333;
}
.d-head-k {
  padding-top: 10px;
  height: 80px;
  color: #40b8ee;
}
.d-head-k .item {
  display: inline-block;
  padding: 5px 15px 5px 0;
}
.d-center,
.d-bottom {
  padding: 0 20px;
}

.state {
  margin: 10px 0;
  font-size: 12px;
}
.state .rate-item {
  margin: 0 10px;
}
.state-text {
  display: inline-block;
  margin-right: 60px;
}
.dialog-video {
  width: 210px;
  height: 620px;
  background-color: #25292d;
}
.dialog-video-list {
  height: 550px;
}
.dialog-video .v-head-title {
  text-align: center;
  padding: 15px 20px;
  color: #fff;
}
.video-item {
  margin-bottom: 20px;
  cursor: pointer;
}
.video {
  width: 180px;
  height: 110px;
  background-color: #40b8ee;
}
.video img{
  width: 100%;
  height: 100%;
}
.video-title {
  width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #f8f9fa;
  padding: 5px 0;
}
</style>
